// extracted by mini-css-extract-plugin
export default {"root":"chip_root__3g+g2","label":"chip_label__g7fTT","iconWrapper":"chip_iconWrapper__P6bpw"};